import { useEffect, useState } from 'react';
import { enableTrackingAndAnalytics } from '../tagHelpers';

function addConsentManagerScriptCode(): void {
  if (typeof document === 'undefined' || !enableTrackingAndAnalytics()) {
    return;
  }
  const script = document.createElement('script');
  script.id = 'Cookiebot';
  script.src = 'https://consent.cookiebot.com/uc.js';
  script.dataset.cbid = 'b47c7ba2-06c3-43b2-b479-89ee17735f03';
  script.async = true;
  script.type = 'text/javascript';
  document.head.append(script);
}
interface WithConsentManagerProps {
  children: JSX.Element;
}

export default function WithConsentManager({
  children,
}: WithConsentManagerProps): JSX.Element | null {
  const [scriptAdded, setScriptAdded] = useState(false);

  useEffect(() => {
    if (scriptAdded) {
      return;
    }

    addConsentManagerScriptCode();
    setScriptAdded(true);
  }, []);

  if (!scriptAdded) {
    return null;
  }

  return children;
}
